export default "__VITE_ASSET__MKOF4K6V__"